import {cssTheme} from '@yandex-delivery/blocks'
import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const slot = css`
  & + &:before {
    left: ${spacing(7)};
    right: ${spacing(1)};
  }
`
export const leadBox = css`
  inline-size: ${spacing(5)};
  block-size: ${spacing(5)};
  background: ${cssTheme.default.day.backgroundMinor};
  border-radius: ${spacing(1.5)};
`
